import {NotificationService} from '../../Services/NotificationService';
import {StorageService} from '../../Services/StorageService';
import {AuthenticationService} from '../../Services/AuthenticationService';
import {EAppUserType} from '../../Data/Data';
import {StateService} from 'angular-ui-router';
import {NavigationService} from '../../Services/NavigationService';
import {PwaInstallService} from '../../Services/PwaInstallService';

export class LoginController {

  static controllerId = 'LoginController';
  static $inject = [
    AuthenticationService.serviceId,
    '$scope',
    '$state',
    StorageService.serviceId,
    NotificationService.serviceId,
    NavigationService.serviceId,
    PwaInstallService.serviceId,
  ];

  password: string;
  userName: string;
  isLoggingIn = false;
  get canInstallPwa(){
    return this.pwaInstall.canInstall();
  }

  constructor(private authentication: AuthenticationService,
              private $scope: ng.IScope,
              private $state: StateService,
              private storage: StorageService,
              private notification: NotificationService,
              private navigation: NavigationService,
              private pwaInstall: PwaInstallService) {

    const loginData = this.storage.getLoginData();
    if (loginData) {
      this.userName = loginData.username;
      this.password = loginData.password;
    }

    const token = this.storage.getToken();
    if (token) {
      this.authentication.loadAppUser().then(appUser => {
        if (appUser) {
          this.navigation.goToMenu();
        }
      });
    }
  }

  async login() {
    this.isLoggingIn = true;
    try {
      const user = await this.authentication.login({
        username: this.userName,
        password: this.password,
        rememberMe: true
      });
      this.isLoggingIn = false;
      console.log(user);
      if (user.appUserType === EAppUserType.Personal || user.appUserType === EAppUserType.Terminal) {
        this.navigation.goToMenu();
      } else {
        this.notification.toastError('Unbekannter Benutzertyp');
      }
    } catch (err) {
      this.isLoggingIn = false;
      const errorMsg = this.readLoginError(err);
      this.notification.toastError(errorMsg);
      this.$scope.$apply(() => {
        this.password = '';
      });
    }
  }

  private readLoginError(error) {
    const status = error.httpReponse.status;
    if (status === 429) {
      const h = error.httpReponse.headers('Retry-After');
      return `Zu viele Loginversuche, versuchen Sie es in ${!!h ? h : 60} Sekunden erneut.`;
    } else {
      return 'Login fehlgeschlagen.';
    }
  }

  settings() {
    this.$state.go('settings');
  }

  /**
   * Handle PWA installation
   */
  async installPwa() {
    if (this.pwaInstall.isIOSDevice()) {
      // For iOS devices, show installation instructions
      this.pwaInstall.showIOSInstructions(document.body);
    } else {
      // For Android devices, show the native install prompt
      try {
        const installed = await this.pwaInstall.showInstallPrompt();
        if (installed) {
          this.notification.toastSuccess('App erfolgreich installiert');
        }
      } catch (error) {
        console.error('Error installing PWA:', error);
        this.notification.toastError('Installation fehlgeschlagen');
      }
    }
  }
}
